import { ProfileSettingsSchema } from '../../.types/ProfileSettings.schema'
import { definitions } from '../../.types/ProfileSettings.schema.json'
import { DynamicSchema } from '@soniq/schema'
import { CleanValuesOptions } from '@pogokid/schema'

export type { ProfileSettingsSchema } from '../../.types/ProfileSettings.schema'
export const profileSettingsJsonSchema = {
  ...definitions.ProfileSettingsSchema,
  definitions,
}
export const profileSettingsCleanValues: CleanValuesOptions = {
  // Preserve an empty `notify_weekly_digest` ({}) rather than letting
  // cleanValues collapse it to null, which would fail its object-type
  // check. An empty object is a valid value meaning "use channel
  // defaults". Mirrors the `meta` handling on ContactSchema.
  shouldCleanProperties(property, value) {
    return (
      property !== 'notify_weekly_digest' ||
      Object.keys(value ?? {}).length > 0
    )
  },
}
export const profileSettingsSchema =
  DynamicSchema.new<ProfileSettingsSchema>({
    id: 'ProfileSettingsSchema',
    jsonSchema: {
      ...definitions.ProfileSettingsSchema,
      definitions,
    },
    cleanValuesOptions: profileSettingsCleanValues,
  })
export * from './guards'
export * from './types'
